export default "__VITE_ASSET__DrxvwMuR__"